import config from 'config'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import * as Page from 'containers/pages'
import { Tabs } from 'components/layout'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'
import { Redirect } from 'react-router-dom'

const routeStructure = ({ urlPrefix, isIac, isTypeId } = {}) => [
  {
    path: `${urlPrefix}`,
    isIac: isIac,
    isTypeId: isTypeId,
    component: props => (
      <Page.AwardUnit
        {...props}
        params={get(props, 'match.params', {})}
        tabs={
          <Tabs {...props} params={get(props, 'match.params', {})} />
        }
      />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: () => (
          <Redirect to={`${urlPrefix}/detail`} />
        )
      },
      {
        path: `${urlPrefix}/detail`,
        exact: true,
        component: props => (
          <Page.AwardUnitDetail {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/participants`,
        exact: true,
        component: props => (
          <Page.AwardUnitParticipants {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/leaders`,
        exact: true,
        component: props => (
          <Page.AwardUnitLeaders {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/registrations`,
        exact: true,
        component: props => (
          <Page.AwardUnitRegistrations {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/payments`,
        isTypeId: isTypeId,
        exact: true,
        component: props => (
          <Page.AwardUnitPayments {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/adventurous-journeys`,
        exact: true,
        component: props => (
          <Page.AwardUnitAjEvents {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/logs`,
        exact: true,
        component: props => (
          <Page.OrganizationHistory {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/customizations`,
        isTypeId: isTypeId,
        exact: true,
        component: props => (
          <Page.AwardUnitCustomizations {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/assessors`,
        exact: true,
        component: props => (
          <Page.AwardUnitAssessors {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${urlPrefix}/labels`,
        exact: true,
        component: props => (
            <Page.AwardUnitLabels {...props} params={get(props, 'match.params', {})} />
        )
      }
    ]
  }
]


const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/award-units`,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})} />
    ),
    routes: [
      {
        path: `${publicPath}/award-units`,
        exact: true,
        component: props => (
          <Page.AwardUnitsList
            {...props}
            params={get(props, 'match.params', {})}
            tabs={
              <Tabs {...props} params={get(props, 'match.params', {})} />
            }
          />
        )
      },
      ...routeStructure({
        urlPrefix: `${publicPath}/award-units/:id`,
        isTypeId: ORGANIZATION_HIERARCHY.AU.id
      })
    ]
  },

  {
    path: `${publicPath}/independent-award-centres`,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})} />
    ),
    routes: [
      {
        path: `${publicPath}/independent-award-centres`,
        exact: true,
        component: props => (
          <Page.IndependentAwardCenters
            {...props}
            params={get(props, 'match.params', {})}
            tabs={
              <Tabs {...props} params={get(props, 'match.params', {})} />
            }
          />
        )
      },
      ...routeStructure({
        urlPrefix: `${publicPath}/independent-award-centres/:id`,
        isIac: true,
        isTypeId: ORGANIZATION_HIERARCHY.IAC.id
      })
    ]
  },

  {
    path: `${publicPath}/aus-iacs`,
    component: props => (
        <Main {...props} params={get(props, 'match.params', {})} />
    ),
    routes: [
      {
        path: `${publicPath}/aus-iacs`,
        exact: true,
        component: props => (
            <Page.OrganizationAUsIACs
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                  <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
      },
      ...routeStructure({
        urlPrefix: `${publicPath}/aus-iacs/:id`,
        isIac: true,
        isTypeId: ORGANIZATION_HIERARCHY.IAC.id
      })
    ]
  }
]

export default routes
